// extracted by mini-css-extract-plugin
module.exports = {"list":"navigation_list__gtaX_","columnSpan":"navigation_columnSpan__83gaG","splitInColumns":"navigation_splitInColumns__99XZZ"};